export default "__VITE_ASSET__1vwql9Tv__";